import { render } from "./index.vue?vue&type=template&id=8ffbde6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8ffbde6c&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=8ffbde6c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffbde6c"]])

export default __exports__